export default "/images/vendor/flag-icons/flags/4x3/mm.svg?82321f19830e8de129b7e0272961caed";